const H2 = ({ children }) => {
  return (
    <h2 className="mb-4 text-xl font-light uppercase text-primary-500 lg:text-2xl 2xl:text-3xl">
      {children}
    </h2>
  )
}

export default H2
